<script>
    import { onDestroy, onMount } from "svelte";

        let slot
        export let id
        export let imgFolder

        let i = 0;
        function init() {
            addImage(1, 1)
            addImage(2)
            i = 2
        }
    
        let end = null
        let commit = false
        let timer
        export function start() {
            end = null
            timer = setInterval(next, 150);
        }
        export function stop(num) {
            if(!end && !commit) {
                end = num;
            }
        }
    
        function addImage(imgIndex, forceImg) {
            const img = document.createElement('img')
            img.id = id+'-'+imgIndex
            if (commit) {
                clearInterval(timer)
                commit = false
                end = null
            } else if(end) {
                img.className = 'bounce'
                commit = true
            }
            img.style.width = '290px';
            img.style.height = '100%';
            img.style['margin-left'] = 0
            img.style.transition = 'margin-left 500ms ease';
            img.src = imgFolder+(forceImg ? forceImg : end ? end : (getRandomInt(7)+1))+'.png'
            slot.appendChild(img)
        }

        function next() {
            addImage(++i)
            const eltToRemove = document.getElementById(id+'-'+(i-2))
            eltToRemove.style['margin-left'] = '-290px';
            setTimeout(function() { slot.removeChild(eltToRemove) }, 500)
        }

        function getRandomInt(max) {
            return Math.floor(Math.random() * Math.floor(max));
        }

        onMount(() => {
            init()
        });

        onDestroy(() => {
            clearInterval(timer)
        })
    </script>
    
    <span id={id} bind:this={slot}></span>

    <style>
        
    </style>
    